export const newFeatures = {
    collection: {
        level: 'Level',
        fix_time: 'Fix times:',
        earn_exercise: 'Earned per excercise:',
        on_selling: 'On selling',
        sell: 'Sell',
        edit: 'Edit',
        buy: 'Buy',
        stop: 'Stop',
        cancel: 'Cancel',
        update: 'Update',
        search: 'Search'
    },
    sort_filter: {
        sort_by: 'Sort by',
        filter: 'Filter',
        status: 'Status',
        sell_in: 'Sell in',
        class: 'Class',
        sale_hight: 'Recent sales',
        sale_low: 'Oldest to Newest',
        level_hight: 'Level: high to low',
        level_low: 'Level: low to high',
        reward_hight: 'Reward: high to low',
        reward_low: 'Reward: low to high',
        fix_time_hight: 'Fix times: high to low',
        fix_time_low: 'Fix times: low to high',
        radio_1: 'Ready to earn',
        radio_2: 'Required fix now',
        radio_3: 'On selling',
        clear_all: 'Clear all'
    },
    modal_sell: {
        fee: 'You will get %{fee} ( ~%{value}) of the value if the sell order is successful.',
        sell_nft: 'Sell NFT',
        edit_nft: 'Edit NFT',
        buy_Nft: 'Buy NFT',
        stop_sell: 'Stop selling',
        want_sell_in:'I want sell in',
        want_buy: 'Do you want to buy this NFT',
        want_stop: 'Do you want to stop selling?',
        code_2fa: '2FA code',
    },
    tab_leaf: {
        payment: 'Payment',
        total_amount: 'Total amount',
        quantity: 'Quantity',
        pay: 'Pay',
        balance: 'Balance',
        limitMessage: 'The current balance is not sufficient!',
        you_have: 'You have:',
        leaf: ' leaf',
    },
    transaction: {
        transaction_history: 'Transaction history',
        type: 'Type',
        item_id: 'Item Id',
        tier: 'Tier',
        level: 'Level',
        price: 'Price',
        token: 'Token',
        seller_buyer: 'Seller/Buyer',
        time: 'Time',
        filter: 'Filter',
        send: 'Send'
    },
    common: {
        price: 'Price',
        noData_market: 'No NFT match your search',
        edit: 'Edit',
        no_transaction: 'You do not have any transaction',
        all: 'All',
        buy: 'Buy',
        sell: 'Sell',
        send: 'Send',
        receive: 'Receive',
        connect: 'Connect',
        amount: 'Amount',
        leaves: 'Leaves',
    },
    tab_ticket: {
        ticket: ' ticket'
    },
}
